import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		// 初始化全局的一个变量
		ButtonPowerList: []
	},
	mutations: {
		modifyButtonPowerList(state, value) {
			state.ButtonPowerList = value;
		}
	}
})

 
export function checkbuttonpower(ButtonPowerList, modulecode) {
	if (item.modulecode == modulecode) {
		return true;
	} else {
		return false;
	}
};


export default store



// WEBPACK FOOTER //
// ./src/store/index.js